/**
 * New copy — no such content existed anywhere in the app before this
 * handoff. Written from the real backend rules found this session
 * (OrganizationsUsersTable::isOwner()/canChangeRole()/
 * canRemoveUserFromOrganization()), not the design's own claim that
 * "Admins can also manage members and billing" — that isn't true today:
 * only Owners can manage members, and Admin/Member are otherwise
 * functionally identical everywhere else in the app (ORG_ROLE_ADMIN is
 * only ever checked inside the OrganizationsUsers forms).
 */
import React from "react";
import Modal from "../../theme/untitled/Modal/Modal";
import Button from "../../theme/untitled/Button/Button";
import Icon from "../../theme/untitled/icons/Icon";
import styles from "./MembersPage.module.scss";

const RolePermissionsDialog = ({ open, onClose }) => (
  <Modal
    open={open}
    onClose={onClose}
    icon={<Icon name="Settings01" size={24} />}
    title="Role permissions"
    footer={
      <Button hierarchy="secondaryGray" onClick={onClose}>
        Close
      </Button>
    }
  >
    <div className={styles.dialogField}>
      <p>
        <strong>Owner</strong> — full control of the workspace: invite and remove members, change
        roles, manage billing and the subscription, and delete the workspace. Every workspace
        needs at least one Owner, so the last one can't be removed or demoted.
      </p>
    </div>
    <div className={styles.dialogField}>
      <p>
        <strong>Admin and Member</strong> — the same day-to-day access: view and edit calendars,
        widgets and the rest of the workspace's content. Only Owners can manage members today.
      </p>
    </div>
  </Modal>
);

export default RolePermissionsDialog;
